export const LOCALE_ID_VALUE = 'id';
